export const DataTableV3LocalStoragePrefixes = {
  columnVisibility: 'DataTableV3_',
  pageSize: 'DataTableV3PageSize_',
  sortingState: 'DataTableSortingState_',
} as const;
